// Render the membership level selector
import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import LevelDescription from "./LevelDescription";

const LevelOptions = (props) => {
  const selectorAction = (e, index) => {
    e.preventDefault();
    props.setSelectedLevel(index);
    props.setValue("membership_level", props.levels[index].id);
  };
  return (
    <>
      {props.levels.map(function (level, index) {
        if (index != 0) {
          if (
            !props.bottomLevel ||
            (props.bottomLevel && props.bottomLevel <= index)
          ) {
            if (props.style == "list") {
              return (
                <button
                  className={props.selected == index ? "selected" : undefined}
                  key={index}
                  onClick={(e) => {
                    selectorAction(e, index);
                  }}
                >
                  {level.name}
                </button>
              );
            } else {
              return (
                <option value={level.id} key={index}>
                  {level.name} member
                </option>
              );
            }
          }
        }
      })}
    </>
  );
};

const LevelSelector = (props) => {
  const [selectedLevel, setSelectedLevel] = useState(props.initialLevel);
  let selectedLevelDetails = props.levels[selectedLevel];
  const { register, setValue } = useFormContext();

  const pulldownAction = (e) => {
    e.preventDefault();
    setSelectedLevel(props.levels.findIndex((x) => x.id === e.target.value));
  };

  if (selectedLevel == 0) {
    return (
      <div className="with-sidebar-main">
        <LevelDescription level={selectedLevelDetails} />
      </div>
    );
  } else {
    return (
      <div className="component-level-selector with-sidebar">
        <div className="selector-nav with-sidebar-side left">
          <LevelOptions
            style="list"
            levels={props.levels}
            selected={selectedLevel}
            bottomLevel={props.bottomLevel}
            setSelectedLevel={setSelectedLevel}
            setValue={setValue}
          />
        </div>
        <div className="with-sidebar-main with-sections">
          <LevelDescription
            level={selectedLevelDetails}
            legacyMember={props.legacyMember}
          />
          <div>
            <h3>Billing information</h3>
            <div className="field">
              <select
                name="membership_level"
                id="membership_level"
                {...register("membership_level", {
                  required: true,
                })}
                value={selectedLevelDetails.id}
                onChange={(e) => {
                  pulldownAction(e);
                }}
              >
                <LevelOptions
                  levels={props.levels}
                  selected={selectedLevel}
                  bottomLevel={props.bottomLevel}
                  style="pulldown"
                  setSelectedLevel={setSelectedLevel}
                />
              </select>
              {selectedLevelDetails.priceValue ? (
                <select
                  name="cc_recurring"
                  id="cc_recurring"
                  {...register("cc_recurring", {
                    required: true,
                  })}
                >
                  <option id="per-month" value="MONT">
                    ${selectedLevelDetails.priceValue} per month
                  </option>

                  <option id="per-quarter" value="QTER">
                    ${selectedLevelDetails.priceValue * 3} per quarter
                  </option>

                  <option id="per-year" value="YEAR">
                    ${selectedLevelDetails.priceValue * 12} per year
                  </option>
                </select>
              ) : (
                <span className="selector-nav-norecur">
                  {selectedLevelDetails.priceLabel}
                </span>
              )}
            </div>
            {selectedLevelDetails.id != "5" ? (
              props.children
            ) : (
              <a
                className="button primary"
                href="mailto:donate@longnow.org?subject=10,000 Year Membership Request"
                target="_blank"
                rel="noopener"
              >
                10,000 Year Membership Request
              </a>
            )}
          </div>
        </div>
      </div>
    );
  }
};
export default LevelSelector;
